import { createContext } from "react";
import { Action } from "../../types/reducer-action";
import { IOrg } from "../../types/org";
import { IPosition } from "../../types/position";
import { IIndividual, ISearchIndividualResult } from "../../types/individual";

export const errorSearch = 'Please perform a search with at least one value filled in other than <b>Under Top Level</b>.';
export const messageSearch = 'After performing a valid search, select an entry to see its details here.';
export const messageAfterSearchResult = 'Please select an entity within the system to view its details';

export interface OrgState {
  orgSearchOrg:IOrg|undefined;
  orgSearchMessage: string|undefined;
  orgSearchError: string|undefined;

  individualSearchOrg:IOrg|undefined;
  individualSearchPosition:IPosition|undefined;
  individualSearchIndividual:IIndividual|undefined;
  individualSearchTitle : IPosition|undefined;
  individualSearchMessage: string|undefined;
  individualSearchError: string|undefined;

  positionSearchOrg:IOrg|undefined;
  positionSearchPosition:IPosition|undefined;
  positionSearchPositionRole:IPosition|undefined;
  positionSearchIndividual:IIndividual|undefined;
  positionSearchMessage: string|undefined;
  positionSearchError: string|undefined;

  // track the last selected item (individual, position, role, etc) 
  lastSelectedItem: any | undefined;
}

export type OrgReducer = [
  OrgState | undefined,
  (action: Action) => void
];

export const OrgReducerContext = createContext<OrgReducer>([undefined, () => { }]);

export const orgReducer = (state: OrgState, action: Action): OrgState => {
  if (action.type === 'reset') {
    return action.payload ?? {};
  }

  const newState = {
    ...state,
  } as OrgState;

  switch (action.type) {
    //org search
    case 'set-org-search-error':
        newState.orgSearchError = action.payload||undefined;
        break;
    case 'set-org-search-message':
        newState.orgSearchMessage = action.payload||undefined;
        break;
    case 'set-org-search-org':
        newState.orgSearchOrg = action.payload; 
        break;    
    //individual search    
    case 'set-individual-search-error':
        newState.individualSearchError = action.payload||undefined;
        break;
    case 'set-individual-search-message':
        newState.individualSearchMessage = action.payload||undefined;
        break;
    case 'set-individual-search-individual':
      newState.individualSearchIndividual = action.payload;
      //delete newState?.message;
      break;
    case 'set-individual-search-position':
      newState.individualSearchPosition = action.payload;
      break;
    case 'set-individual-search-org':
      newState.individualSearchOrg = action.payload; 
      break;
    case 'set-individual-search-title':
      newState.individualSearchTitle = action.payload; 
      break;
    //position search
    case 'set-position-search-error':
        newState.positionSearchError = action.payload||undefined;
        break;
    case 'set-position-search-message':
        newState.positionSearchMessage = action.payload||undefined;
        break;
    case 'set-position-search-individual':
      newState.positionSearchIndividual = action.payload;
      break;
    case 'set-position-search-position':
      newState.positionSearchPosition = action.payload;
      break;
    case 'set-position-search-position-role':
      newState.positionSearchPositionRole = action.payload;
      break;
    case 'set-position-search-org':
      newState.positionSearchOrg = action.payload; 
      break;
    case 'set-last-selected-item':
      newState.lastSelectedItem = action.payload;
      break;
    default:
      throw Error('Unknown action type: ' + action.type);
  }

  return newState;
};
